import { Fragment } from 'react';
import {
	TStatusItem,
	STATUS_ISSUES,
	SHIPMENT_STATUS,
	POD_STATUS_NUM,
	POD_STATUS,
	INVOICE_STATUS_LABEL,
	CHIP_TYPE,
	TIMESLOT_STATUS,
	TIMESLOT_STATUS_OPTIONS
} from '@types';
import FeedbackOutlinedIcon from '@mui/icons-material/FeedbackOutlined';
import ScheduleOutlinedIcon from '@mui/icons-material/ScheduleOutlined';
import CORSafetyIcon from '@mui/icons-material/GppMaybeOutlined';
import PendingOutlined from '@mui/icons-material/PendingOutlined';
import Schedule from '@mui/icons-material/Schedule';
import PeopleAltOutlined from '@mui/icons-material/PeopleAltOutlined';
import LocationOnOutlined from '@mui/icons-material/LocationOnOutlined';
import AttachMoneyOutlined from '@mui/icons-material/AttachMoneyOutlined';
import CancelOutlined from '@mui/icons-material/CancelOutlined';
import DoNotDisturbOutlined from '@mui/icons-material/DoNotDisturbOutlined';
import ArticleOutlined from '@mui/icons-material/ArticleOutlined';
import HourglassEmptyOutlined from '@mui/icons-material/HourglassEmptyOutlined';
import UploadFileOutlined from '@mui/icons-material/UploadFileOutlined';
import ErrorOutlineOutlined from '@mui/icons-material/ErrorOutlineOutlined';
import HistoryToggleOffOutlined from '@mui/icons-material/HistoryToggleOffOutlined';
import TaskOutlined from '@mui/icons-material/TaskOutlined';
import HandshakeOutlined from '@mui/icons-material/HandshakeOutlined';
import PaidOutlined from '@mui/icons-material/PaidOutlined';
import ReceiptOutlined from '@mui/icons-material/ReceiptOutlined';
import CreditCardOutlined from '@mui/icons-material/CreditCardOutlined';
import MoneyOffCsredOutlined from '@mui/icons-material/MoneyOffCsredOutlined';
import CheckCircleOutlineIcon from '@mui/icons-material/CheckCircleOutline';
import AccessTimeOutlinedIcon from '@mui/icons-material/AccessTimeOutlined';
import {
	LoadDroppedIcon,
	FreightIssuesIcon,
	PODRejectedIcon,
	PODAwaitingVerificationIcon,
	NoPODAvailableIcon,
	LoadNotDeliveredIcon,
	OverdueShipmentPaymentIcon,
	PersonAlertIcon,
	InvoiceMissingIcon,
	AwaitingCarrierInvoiceIcon,
	CarrierInvoicePendingIcon,
	CommentDisputeIcon
} from '@img/icons';

type TStatuses = {
	issues: TStatusItem[];
	shipper: TStatusItem[];
	carrier: TStatusItem[];
	timeslots: TStatusItem[];
	admin: {
		shipment: TStatusItem[];
		pod: TStatusItem[];
		shipperInvoice: TStatusItem[];
		carrierInvoice: TStatusItem[];
	}
}

export const statuses: TStatuses = {
	issues: [
		{
			key: STATUS_ISSUES.COMPLAINT,
			value: STATUS_ISSUES.COMPLAINT,
			label: 'Complaint',
			short: 'Complaint',
			type: CHIP_TYPE.ERROR,
			icon: FeedbackOutlinedIcon,
			canedit: false,
			can_admin_edit: false,
			candelete: false,
			can_admin_delete: false,
		}, {
			key: STATUS_ISSUES.TIME_SLOT,
			value: STATUS_ISSUES.TIME_SLOT,
			label: 'Time Slot',
			short: 'Time Slot',
			type: CHIP_TYPE.ERROR,
			icon: ScheduleOutlinedIcon,
			canedit: false,
			can_admin_edit: false,
			candelete: false,
			can_admin_delete: false,
		}, {
			key: STATUS_ISSUES.DROPPED_LOAD,
			value: STATUS_ISSUES.DROPPED_LOAD,
			label: 'Dropped Load',
			short: 'Dropped Load',
			type: CHIP_TYPE.ERROR,
			icon: LoadDroppedIcon,
			canedit: false,
			can_admin_edit: false,
			candelete: false,
			can_admin_delete: false,
		}, {
			key: STATUS_ISSUES.FREIGHT_ISSUES,
			value: STATUS_ISSUES.FREIGHT_ISSUES,
			label: 'Freight Issues',
			short: 'Freight Issues',
			type: CHIP_TYPE.ERROR,
			icon: FreightIssuesIcon,
			canedit: false,
			can_admin_edit: false,
			candelete: false,
			can_admin_delete: false,
		}, {
			key: STATUS_ISSUES.COR_SAFETY_INCIDENT,
			value: STATUS_ISSUES.COR_SAFETY_INCIDENT,
			label: 'CoR/Safety Incident',
			short: 'CoR/Safety Incident',
			type: CHIP_TYPE.ERROR,
			icon: CORSafetyIcon,
			canedit: false,
			can_admin_edit: false,
			candelete: false,
			can_admin_delete: false,
		},
	],
	shipper: [
		{
			key: 'pending',
			value: SHIPMENT_STATUS.PENDING,
			label: 'Awaiting allocation.',
			short: 'Pending',
			type: CHIP_TYPE.WARN,
			icon: PendingOutlined,
			canedit: true,
			can_admin_edit: true,
			candelete: true,
			can_admin_delete: true,
		}, {
			key: 'allocated-delayed',
			value: SHIPMENT_STATUS.ALLOCATED,
			label: 'This shipment may be delayed, we are investigating for you.',
			short: 'On The Road',
			type: CHIP_TYPE.INFO,
			icon: Schedule,
			canedit: true,
			can_admin_edit: true,
			candelete: false,
			can_admin_delete: true,
		}, {
			key: 'allocated-started',
			value: SHIPMENT_STATUS.ALLOCATED,
			label: 'This shipment is on the way.',
			short: 'On The Road',
			type: CHIP_TYPE.INFO,
			icon: Schedule,
			canedit: true,
			can_admin_edit: true,
			candelete: false,
			can_admin_delete: true,
		}, {
			key: 'allocated',
			value: SHIPMENT_STATUS.ALLOCATED,
			label: 'Your shipment is allocated to a driver.',
			short: 'Allocated',
			type: CHIP_TYPE.INFO,
			icon: PeopleAltOutlined,
			canedit: true,
			can_admin_edit: true,
			candelete: false,
			can_admin_delete: true,
		}, {
			key: 'pickup-delayed',
			value: SHIPMENT_STATUS.PICKUP,
			label: 'This shipment may be delayed, we are investigating for you.',
			short: 'On The Road',
			type: CHIP_TYPE.INFO,
			icon: Schedule,
			canedit: true,
			can_admin_edit: true,
			candelete: false,
			can_admin_delete: true,
		}, {
			key: 'pickup',
			value: SHIPMENT_STATUS.PICKUP,
			label: 'This shipment is on the way.',
			short: 'On The Road',
			type: CHIP_TYPE.INFO,
			icon: Schedule,
			canedit: false,
			can_admin_edit: true,
			candelete: false,
			can_admin_delete: true,
		}, {
			key: 'delivered',
			value: SHIPMENT_STATUS.DELIVERED,
			label: 'This shipment has been delivered.',
			short: 'Delivered',
			type: CHIP_TYPE.SUCCESS,
			icon: LocationOnOutlined,
			canedit: false,
			can_admin_edit: true,
			candelete: false,
			can_admin_delete: false,
		}, {
			key: 'pod-received',
			value: SHIPMENT_STATUS.POD_RECEIVED,
			label: 'This shipment has been delivered.',
			short: 'Delivered',
			type: CHIP_TYPE.SUCCESS,
			icon: LocationOnOutlined,
			canedit: false,
			can_admin_edit: true,
			candelete: false,
			can_admin_delete: false,
		}, {
			key: 'complete',
			value: SHIPMENT_STATUS.COMPLETE,
			label: 'We are awaiting your payment.',
			short: 'Awaiting',
			type: CHIP_TYPE.WARN,
			icon: PendingOutlined,
			canedit: false,
			can_admin_edit: false,
			candelete: false,
			can_admin_delete: false,
		}, {
			key: 'paid',
			value: SHIPMENT_STATUS.PAID,
			label: 'The shipment is complete and we have received payment, thank you.',
			short: 'Paid',
			type: CHIP_TYPE.SUCCESS,
			icon: AttachMoneyOutlined,
			canedit: false,
			can_admin_edit: false,
			candelete: false,
			can_admin_delete: false,
		}, {
			key: 'cancelled',
			value: SHIPMENT_STATUS.CANCELLED,
			label: 'Shipment was cancelled',
			short: 'Cancelled',
			type: CHIP_TYPE.ERROR,
			icon: CancelOutlined,
			canedit: false,
			can_admin_edit: false,
			candelete: false,
			can_admin_delete: false,
		},
	],
	carrier: [
		{
			key: 'allocated-delayed',
			value: SHIPMENT_STATUS.ALLOCATED,
			label: 'This load is running late, please update milestone',
			short: 'On The Road',
			type: CHIP_TYPE.INFO,
			icon: Schedule,
			canedit: true,
			can_admin_edit: true,
			candelete: false,
			can_admin_delete: true,
		}, {
			key: 'allocated-started',
			value: SHIPMENT_STATUS.ALLOCATED,
			label: 'This load is in transit',
			short: 'On The Road',
			type: CHIP_TYPE.INFO,
			icon: Schedule,
			canedit: true,
			can_admin_edit: true,
			candelete: false,
			can_admin_delete: true,
		}, {
			key: 'allocated',
			value: SHIPMENT_STATUS.ALLOCATED,
			label: 'You have not started this load yet.',
			short: 'Not Started',
			type: CHIP_TYPE.NEUTRAL,
			icon: DoNotDisturbOutlined,
			canedit: true,
			can_admin_edit: true,
			candelete: false,
			can_admin_delete: true,
		}, {
			key: 'pickup-delayed',
			value: SHIPMENT_STATUS.PICKUP,
			label: 'This load is running late, please update milestone',
			short: 'On The Road',
			type: CHIP_TYPE.INFO,
			icon: Schedule,
			canedit: true,
			can_admin_edit: true,
			candelete: false,
			can_admin_delete: true,
		}, {
			key: 'pickup',
			value: SHIPMENT_STATUS.PICKUP,
			label: 'This load is in transit.',
			short: 'On The Road',
			type: CHIP_TYPE.INFO,
			icon: Schedule,
			canedit: false,
			can_admin_edit: true,
			candelete: false,
			can_admin_delete: true,
		}, {
			key: 'delivered',
			value: SHIPMENT_STATUS.DELIVERED,
			label: 'Upload your POD so you can be paid.',
			short: 'POD Required',
			type: CHIP_TYPE.WARN,
			icon: ArticleOutlined,
			canedit: false,
			can_admin_edit: false,
			candelete: false,
			can_admin_delete: false,
		}, {
			key: 'pod-rejected',
			value: SHIPMENT_STATUS.POD_RECEIVED,
			label: 'Please re-upload the correct POD.',
			short: 'POD Rejected',
			type: CHIP_TYPE.ERROR,
			icon: PODRejectedIcon,
			canedit: false,
			can_admin_edit: false,
			candelete: false,
			can_admin_delete: false,
		}, {
			key: 'pod-received',
			value: SHIPMENT_STATUS.POD_RECEIVED,
			label: 'We are verifying your POD.',
			short: 'POD Awaiting Verification',
			type: CHIP_TYPE.WARN,
			icon: PODAwaitingVerificationIcon,
			canedit: false,
			can_admin_edit: false,
			candelete: false,
			can_admin_delete: false,
		}, {
			key: 'complete',
			value: SHIPMENT_STATUS.COMPLETE,
			label: 'We are awaiting your invoice for this load.',
			short: 'Awaiting Invoice',
			type: CHIP_TYPE.WARN,
			icon: PendingOutlined,
			canedit: false,
			can_admin_edit: false,
			candelete: false,
			can_admin_delete: false,
		}, {
			key: 'paid',
			value: SHIPMENT_STATUS.COMPLETE,
			label: 'You have been paid for this load.',
			short: 'Paid',
			type: CHIP_TYPE.SUCCESS,
			icon: AttachMoneyOutlined,
			canedit: false,
			can_admin_edit: false,
			candelete: false,
			can_admin_delete: false,
		},
	],
	timeslots: [
		{
			key: TIMESLOT_STATUS.CONFIRMED,
			value: TIMESLOT_STATUS_OPTIONS.CONFIRMED,
			label: TIMESLOT_STATUS_OPTIONS.CONFIRMED,
			short: TIMESLOT_STATUS_OPTIONS.CONFIRMED,
			type: CHIP_TYPE.SUCCESS,
			icon: CheckCircleOutlineIcon,
			canedit: false,
			can_admin_edit: true,
			candelete: false,
			can_admin_delete: false,
		}, {
			key: TIMESLOT_STATUS.REJECTED,
			value: TIMESLOT_STATUS_OPTIONS.REJECTED,
			label: TIMESLOT_STATUS_OPTIONS.REJECTED,
			short: TIMESLOT_STATUS_OPTIONS.REJECTED,
			type: CHIP_TYPE.ERROR,
			icon: CancelOutlined,
			canedit: false,
			can_admin_edit: true,
			candelete: false,
			can_admin_delete: false,
		}, {
			key: TIMESLOT_STATUS.REQUIRED,
			value: TIMESLOT_STATUS_OPTIONS.REQUIRED,
			label: TIMESLOT_STATUS_OPTIONS.REQUIRED,
			short: TIMESLOT_STATUS_OPTIONS.REQUIRED,
			type: CHIP_TYPE.WARN,
			icon: AccessTimeOutlinedIcon,
			canedit: false,
			can_admin_edit: true,
			candelete: false,
			can_admin_delete: false,
		}, {
			key: TIMESLOT_STATUS.REQUESTED,
			value: TIMESLOT_STATUS_OPTIONS.REQUESTED,
			label: TIMESLOT_STATUS_OPTIONS.REQUESTED,
			short: TIMESLOT_STATUS_OPTIONS.REQUESTED,
			type: CHIP_TYPE.WARN,
			icon: PendingOutlined,
			canedit: false,
			can_admin_edit: true,
			candelete: false,
			can_admin_delete: false,
		}, {
			key: '',
			value: TIMESLOT_STATUS_OPTIONS.NOT_REQUIRED,
			label: TIMESLOT_STATUS_OPTIONS.NOT_REQUIRED,
			short: TIMESLOT_STATUS_OPTIONS.NOT_REQUIRED,
			type: CHIP_TYPE.NEUTRAL,
			icon: Fragment,
			canedit: false,
			can_admin_edit: true,
			candelete: false,
			can_admin_delete: false,
		}
	],
	admin: {
		shipment: [
			{
				key: 'pending',
				value: SHIPMENT_STATUS.PENDING,
				label: 'Awaiting allocation.',
				short: 'Pending',
				type: CHIP_TYPE.WARN,
				icon: PendingOutlined,
				canedit: true,
				can_admin_edit: true,
				candelete: true,
				can_admin_delete: true,
			}, {
				key: 'pending review',
				value: SHIPMENT_STATUS.PENDING,
				label: 'Awaiting allocation.',
				short: 'Pending',
				type: CHIP_TYPE.WARN,
				icon: PendingOutlined,
				canedit: true,
				can_admin_edit: true,
				candelete: true,
				can_admin_delete: true,
			}, {
				key: 'allocated-delayed',
				value: SHIPMENT_STATUS.ALLOCATED,
				label: 'The carrier is running late with picking up OR dropping off this load, please update milestone once information received.',
				short: 'On The Road',
				type: CHIP_TYPE.INFO,
				icon: Schedule,
				canedit: true,
				can_admin_edit: true,
				candelete: false,
				can_admin_delete: true,
			}, {
				key: 'allocated-started',
				value: SHIPMENT_STATUS.ALLOCATED,
				label: 'This shipment is on the way.',
				short: 'On The Road',
				type: CHIP_TYPE.INFO,
				icon: Schedule,
				canedit: true,
				can_admin_edit: true,
				candelete: false,
				can_admin_delete: true,
			}, {
				key: 'allocated',
				value: SHIPMENT_STATUS.ALLOCATED,
				label: 'Assigned to a carrier.',
				short: 'Allocated',
				type: CHIP_TYPE.INFO,
				icon: PeopleAltOutlined,
				canedit: true,
				can_admin_edit: true,
				candelete: false,
				can_admin_delete: true,
			}, {
				key: 'pickup-delayed',
				value: SHIPMENT_STATUS.PICKUP,
				label: 'The carrier is running late with picking up OR dropping off this load, please update milestone once information received.',
				short: 'On The Road',
				type: CHIP_TYPE.INFO,
				icon: Schedule,
				canedit: true,
				can_admin_edit: true,
				candelete: false,
				can_admin_delete: true,
			}, {
				key: 'pickup',
				value: SHIPMENT_STATUS.PICKUP,
				label: 'This shipment is on the way.',
				short: 'On The Road',
				type: CHIP_TYPE.INFO,
				icon: Schedule,
				canedit: false,
				can_admin_edit: true,
				candelete: false,
				can_admin_delete: true,
			}, {
				key: 'on the road',
				value: SHIPMENT_STATUS.PICKUP,
				label: 'This shipment is on the way.',
				short: 'On The Road',
				type: CHIP_TYPE.INFO,
				icon: Schedule,
				canedit: false,
				can_admin_edit: true,
				candelete: false,
				can_admin_delete: true,
			}, {
				key: 'delivered delayed',
				value: SHIPMENT_STATUS.DELIVERED,
				label: 'This shipment has been delivered.',
				short: 'Delivered',
				type: CHIP_TYPE.SUCCESS,
				icon: LocationOnOutlined,
				canedit: false,
				can_admin_edit: false,
				candelete: false,
				can_admin_delete: false,
			}, {
				key: 'to check',
				value: SHIPMENT_STATUS.DELIVERED,
				label: 'This shipment has been delivered.',
				short: 'Delivered',
				type: CHIP_TYPE.SUCCESS,
				icon: LocationOnOutlined,
				canedit: false,
				can_admin_edit: false,
				candelete: false,
				can_admin_delete: false,
			}, {
				key: 'delivered',
				value: SHIPMENT_STATUS.DELIVERED,
				label: 'This shipment has been delivered.',
				short: 'Delivered',
				type: CHIP_TYPE.SUCCESS,
				icon: LocationOnOutlined,
				canedit: false,
				can_admin_edit: false,
				candelete: false,
				can_admin_delete: false,
			}, {
				key: 'pod-received',
				value: SHIPMENT_STATUS.DELIVERED,
				label: 'This shipment has been delivered.',
				short: 'Delivered',
				type: CHIP_TYPE.SUCCESS,
				icon: LocationOnOutlined,
				canedit: false,
				can_admin_edit: false,
				candelete: false,
				can_admin_delete: false,
			}, {
				key: 'complete',
				value: SHIPMENT_STATUS.DELIVERED,
				label: 'This shipment has been delivered.',
				short: 'Delivered',
				type: CHIP_TYPE.SUCCESS,
				icon: LocationOnOutlined,
				canedit: false,
				can_admin_edit: false,
				candelete: false,
				can_admin_delete: false,
			}, {
				key: 'cancelled',
				value: SHIPMENT_STATUS.CANCELLED,
				label: 'Shipment was cancelled',
				short: 'Cancelled',
				type: CHIP_TYPE.ERROR,
				icon: CancelOutlined,
				canedit: false,
				can_admin_edit: false,
				candelete: false,
				can_admin_delete: false,
			}, {
				key: 'awaiting',
				value: SHIPMENT_STATUS.COMPLETE,
				label: 'We are awaiting your payment.',
				short: 'Awaiting',
				type: CHIP_TYPE.WARN,
				icon: PendingOutlined,
				canedit: false,
				can_admin_edit: false,
				candelete: false,
				can_admin_delete: false,
			},
		],
		pod: [
			{
				key: 'awaiting',
				value: POD_STATUS_NUM.POD_REQUIRED,
				label: POD_STATUS.POD_REQUIRED,
				short: POD_STATUS.POD_REQUIRED,
				type: CHIP_TYPE.WARN,
				icon: UploadFileOutlined,
				canedit: false,
				can_admin_edit: false,
				candelete: false,
				can_admin_delete: false,
			}, {
				key: 'rejected',
				value: POD_STATUS_NUM.POD_REJECTED,
				label: POD_STATUS.POD_REJECTED,
				short: POD_STATUS.POD_REJECTED,
				type: CHIP_TYPE.ERROR,
				icon: PODRejectedIcon,
				canedit: false,
				can_admin_edit: false,
				candelete: false,
				can_admin_delete: false,
			}, {
				key: 'auto-rejected',
				value: POD_STATUS_NUM.POD_AUTO_REJECTED,
				label: POD_STATUS.POD_AUTO_REJECTED,
				short: POD_STATUS.POD_AUTO_REJECTED,
				type: CHIP_TYPE.ERROR,
				icon: PODRejectedIcon,
				canedit: false,
				can_admin_edit: false,
				candelete: false,
				can_admin_delete: false,
			}, {
				key: 'approved',
				value: POD_STATUS_NUM.POD_VERIFIED,
				label: POD_STATUS.POD_VERIFIED,
				short: POD_STATUS.POD_VERIFIED,
				type: CHIP_TYPE.SUCCESS,
				icon: TaskOutlined,
				canedit: false,
				can_admin_edit: false,
				candelete: false,
				can_admin_delete: false,
			}, {
				key: 'auto-approved',
				value: POD_STATUS_NUM.POD_AUTO_APPROVED,
				label: POD_STATUS.POD_AUTO_APPROVED,
				short: POD_STATUS.POD_AUTO_APPROVED,
				type: CHIP_TYPE.SUCCESS,
				icon: TaskOutlined,
				canedit: false,
				can_admin_edit: false,
				candelete: false,
				can_admin_delete: false,
			}, {
				key: 'verified-processing',
				value: POD_STATUS_NUM.POD_VERIFIED_PROCESSING,
				label: POD_STATUS.POD_VERIFIED_PROCESSING,
				short: POD_STATUS.POD_VERIFIED_PROCESSING,
				type: CHIP_TYPE.INFO,
				icon: CheckCircleOutlineIcon,
				canedit: false,
				can_admin_edit: false,
				candelete: false,
				can_admin_delete: false,
			}, {
				key: 'awaiting-verify',
				value: POD_STATUS_NUM.POD_AWAITING_VERIFICATION,
				label: POD_STATUS.POD_AWAITING_VERIFICATION,
				short: POD_STATUS.POD_AWAITING_VERIFICATION,
				type: CHIP_TYPE.WARN,
				icon: PODAwaitingVerificationIcon,
				canedit: false,
				can_admin_edit: false,
				candelete: false,
				can_admin_delete: false,
			}, {
				key: 'chasing',
				value: POD_STATUS_NUM.POD_CHASING,
				label: POD_STATUS.POD_CHASING,
				short: POD_STATUS.POD_CHASING,
				type: CHIP_TYPE.ERROR,
				icon: HistoryToggleOffOutlined,
				canedit: false,
				can_admin_edit: false,
				candelete: false,
				can_admin_delete: false,
			}, {
				key: 'in-dispute',
				value: POD_STATUS_NUM.POD_IN_DISPUTE,
				label: POD_STATUS.POD_IN_DISPUTE,
				short: POD_STATUS.POD_IN_DISPUTE,
				type: CHIP_TYPE.ERROR,
				icon: ErrorOutlineOutlined,
				canedit: false,
				can_admin_edit: false,
				candelete: false,
				can_admin_delete: false,
			}, {
				key: 'chased-and-abandoned',
				value: POD_STATUS_NUM.POD_CHASED_AND_ABANDONED,
				label: POD_STATUS.POD_CHASED_AND_ABANDONED,
				short: POD_STATUS.POD_CHASED_AND_ABANDONED,
				type: CHIP_TYPE.NEUTRAL,
				icon: DoNotDisturbOutlined,
				canedit: false,
				can_admin_edit: false,
				candelete: false,
				can_admin_delete: false,
			}, {
				key: 'not-available',
				value: POD_STATUS_NUM.POD_NOT_AVAILABLE,
				label: POD_STATUS.POD_NOT_AVAILABLE,
				short: 'Advising Not Available',
				type: CHIP_TYPE.NEUTRAL,
				icon: NoPODAvailableIcon,
				canedit: false,
				can_admin_edit: false,
				candelete: false,
				can_admin_delete: false,
			}, {
				key: 'load-not-delivered',
				value: POD_STATUS_NUM.LOAD_NOT_DELIVERED,
				label: POD_STATUS.LOAD_NOT_DELIVERED,
				short: POD_STATUS.LOAD_NOT_DELIVERED,
				type: CHIP_TYPE.ERROR,
				icon: LoadNotDeliveredIcon,
				canedit: false,
				can_admin_edit: false,
				candelete: false,
				can_admin_delete: false,
			}, {
				key: 'shipper-chasing',
				value: POD_STATUS_NUM.POD_SHIPPER_CHASING,
				label: POD_STATUS.POD_SHIPPER_CHASING,
				short: POD_STATUS.POD_SHIPPER_CHASING,
				type: CHIP_TYPE.ERROR,
				icon: HistoryToggleOffOutlined,
				canedit: false,
				can_admin_edit: false,
				candelete: false,
				can_admin_delete: false,
			}, {
				key: 'rejected-by-shipper',
				value: POD_STATUS_NUM.POD_REJECTED_BY_SHIPPER,
				label: POD_STATUS.POD_REJECTED_BY_SHIPPER,
				short: POD_STATUS.POD_REJECTED_BY_SHIPPER,
				type: CHIP_TYPE.ERROR,
				icon: PODRejectedIcon,
				canedit: false,
				can_admin_edit: false,
				candelete: false,
				can_admin_delete: false,
			},
		],
		shipperInvoice: [
			{
				key: 'shipper-awaiting-invoice',
				value: 'shipper-awaiting-invoice',
				label: INVOICE_STATUS_LABEL.AWAITING_SHIPPER_INVOICE,
				short: INVOICE_STATUS_LABEL.AWAITING_SHIPPER_INVOICE,
				type: CHIP_TYPE.WARN,
				icon: HourglassEmptyOutlined,
				canedit: false,
				can_admin_edit: false,
				candelete: false,
				can_admin_delete: false,
			}, {
				key: 'shipper-invoice-generated',
				value: 'shipper-invoice-generated',
				label: INVOICE_STATUS_LABEL.SHIPPER_INVOICE_GENERATED,
				short: INVOICE_STATUS_LABEL.SHIPPER_INVOICE_GENERATED,
				type: CHIP_TYPE.WARN,
				icon: ArticleOutlined,
				canedit: false,
				can_admin_edit: false,
				candelete: false,
				can_admin_delete: false,
			}, {
				key: 'shipper-invoiced',
				value: 'shipper-invoiced',
				label: INVOICE_STATUS_LABEL.SHIPPER_INVOICE,
				short: INVOICE_STATUS_LABEL.SHIPPER_INVOICE,
				type: CHIP_TYPE.WARN,
				icon: ReceiptOutlined,
				canedit: false,
				can_admin_edit: false,
				candelete: false,
				can_admin_delete: false,
			}, {
				key: 'shipper-payment-overdue',
				value: 'shipper-payment-overdue',
				label: INVOICE_STATUS_LABEL.OVERDUE_SHIPPER_PAYMENT,
				short: INVOICE_STATUS_LABEL.OVERDUE_SHIPPER_PAYMENT,
				type: CHIP_TYPE.ERROR,
				icon: OverdueShipmentPaymentIcon,
				canedit: false,
				can_admin_edit: false,
				candelete: false,
				can_admin_delete: false,
			}, {
				key: 'shipper-paid',
				value: 'shipper-paid',
				label: INVOICE_STATUS_LABEL.SHIPPER_PAID,
				short: INVOICE_STATUS_LABEL.SHIPPER_PAID,
				type: CHIP_TYPE.SUCCESS,
				icon: AttachMoneyOutlined,
				canedit: false,
				can_admin_edit: false,
				candelete: false,
				can_admin_delete: false,
			}, {
				key: 'shipper-payment-dispute',
				value: 'shipper-payment-dispute',
				label: INVOICE_STATUS_LABEL.PAYMENT_DISPUTE,
				short: INVOICE_STATUS_LABEL.PAYMENT_DISPUTE,
				type: CHIP_TYPE.ERROR,
				icon: CommentDisputeIcon,
				canedit: false,
				can_admin_edit: false,
				candelete: false,
				can_admin_delete: false,
			}, {
				key: 'shipper-promised-to-pay',
				value: 'shipper-promised-to-pay',
				label: INVOICE_STATUS_LABEL.SHIPPER_PROMISED_TO_PAY,
				short: INVOICE_STATUS_LABEL.SHIPPER_PROMISED_TO_PAY,
				type: CHIP_TYPE.WARN,
				icon: HandshakeOutlined,
				canedit: false,
				can_admin_edit: false,
				candelete: false,
				can_admin_delete: false,
			},
		],
		carrierInvoice: [
			{
				key: 'carrier-awaiting-invoice',
				value: 'carrier-awaiting-invoice',
				label: INVOICE_STATUS_LABEL.AWAITING_CARRIER_INVOICE,
				short: INVOICE_STATUS_LABEL.AWAITING_CARRIER_INVOICE,
				type: CHIP_TYPE.WARN,
				icon: AwaitingCarrierInvoiceIcon,
				canedit: false,
				can_admin_edit: false,
				candelete: false,
				can_admin_delete: false,
			}, {
				key: 'carrier-invoiced',
				value: 'carrier-invoiced',
				label: INVOICE_STATUS_LABEL.CARRIER_INVOICED,
				short: INVOICE_STATUS_LABEL.CARRIER_INVOICED,
				type: CHIP_TYPE.WARN,
				icon: ReceiptOutlined,
				canedit: false,
				can_admin_edit: false,
				candelete: false,
				can_admin_delete: false,
			}, {
				key: 'carrier-paid-rcti',
				value: 'carrier-paid-rcti',
				label: INVOICE_STATUS_LABEL.CARRIER_PAID_RCTI,
				short: INVOICE_STATUS_LABEL.CARRIER_PAID_RCTI,
				type: CHIP_TYPE.SUCCESS,
				icon: CreditCardOutlined,
				canedit: false,
				can_admin_edit: false,
				candelete: false,
				can_admin_delete: false,
			}, {
				key: 'carrier-paid-butn',
				value: 'carrier-paid-butn',
				label: INVOICE_STATUS_LABEL.CARRIER_PAID_BUTN,
				short: INVOICE_STATUS_LABEL.CARRIER_PAID_BUTN,
				type: CHIP_TYPE.SUCCESS,
				icon: PaidOutlined,
				canedit: false,
				can_admin_edit: false,
				candelete: false,
				can_admin_delete: false,
			}, {
				key: 'carrier-paid',
				value: 'carrier-paid',
				label: INVOICE_STATUS_LABEL.CARRIER_PAID,
				short: INVOICE_STATUS_LABEL.CARRIER_PAID,
				type: CHIP_TYPE.SUCCESS,
				icon: AttachMoneyOutlined,
				canedit: false,
				can_admin_edit: false,
				candelete: false,
				can_admin_delete: false,
			}, {
				key: 'carrier-paid-manual-rec',
				value: 'carrier-paid-manual-rec',
				label: INVOICE_STATUS_LABEL.CARRIER_PAID_MANUAL_REC,
				short: INVOICE_STATUS_LABEL.CARRIER_PAID_MANUAL_REC,
				type: CHIP_TYPE.SUCCESS,
				icon: AttachMoneyOutlined,
				canedit: false,
				can_admin_edit: false,
				candelete: false,
				can_admin_delete: false,
			},
			{
				key: 'carrier-pending-or-chasing',
				value: 'carrier-pending-or-chasing',
				label: INVOICE_STATUS_LABEL.PENDING_OR_CHASING,
				short: INVOICE_STATUS_LABEL.PENDING_OR_CHASING,
				type: CHIP_TYPE.WARN,
				icon: CarrierInvoicePendingIcon,
				canedit: false,
				can_admin_edit: false,
				candelete: false,
				can_admin_delete: false,
			}, {
				key: 'carrier-no-invoice-provided',
				value: 'carrier-no-invoice-provided',
				label: INVOICE_STATUS_LABEL.NO_INVOICE_PROVIDED,
				short: INVOICE_STATUS_LABEL.NO_INVOICE_PROVIDED,
				type: CHIP_TYPE.NEUTRAL,
				icon: InvoiceMissingIcon,
				canedit: false,
				can_admin_edit: false,
				candelete: false,
				can_admin_delete: false,
			}, {
				key: 'carrier-payment-dispute',
				value: 'carrier-payment-dispute',
				label: INVOICE_STATUS_LABEL.CARRIER_PAYMENT_DISPUTE,
				short: INVOICE_STATUS_LABEL.CARRIER_PAYMENT_DISPUTE,
				type: CHIP_TYPE.ERROR,
				icon: PersonAlertIcon,
				canedit: false,
				can_admin_edit: false,
				candelete: false,
				can_admin_delete: false,
			}, {
				key: 'carrier-do-not-pay',
				value: 'carrier-do-not-pay',
				label: INVOICE_STATUS_LABEL.CARRIER_DO_NOT_PAY,
				short: INVOICE_STATUS_LABEL.CARRIER_DO_NOT_PAY,
				type: CHIP_TYPE.ERROR,
				icon: MoneyOffCsredOutlined,
				canedit: false,
				can_admin_edit: false,
				candelete: false,
				can_admin_delete: false,
			},
		]
	}
}

export const getStatus = (type: string, key: string | number, isAdmin: boolean = false): TStatusItem | null => {
	if (isAdmin) {
		const status = (statuses.admin[type as keyof typeof statuses.admin] as TStatusItem[])?.find((s) => s.key === key);
		return status ?? null;
	} else {
		const status = (statuses[type as keyof typeof statuses] as TStatusItem[])?.find((s) => s.key === key);
		return status ?? null;
	}
}
